import './frontend.scss';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet/dist/leaflet.js';
import { markerIconSVG } from './src/MarkerMethods.js';

class Map {
    constructor(wrapper) {
        this.wrapper = wrapper;
        this.markers = [];

        try {
            this.locations = JSON.parse(wrapper.dataset.markers || '[]');
        }
        catch (error) {
            console.error('Unable to parse Maps block markers:', error);
            this.locations = [];
        }

        this.init();
    }

    init() {
        const zoom = Number.parseInt(this.wrapper.dataset.zoom, 10) || 11;
        let center;
        try {
            center = JSON.parse(this.wrapper.dataset.center || '{"lat":-37.7788,"lng":145.3129}');
        }
        catch (error) {
            console.error('Unable to parse Maps block centre:', error);
            center = { lat: -25.9182232, lng: 134.0707271 };
        }

        this.map = L.map(this.wrapper, {
            zoom,
            scrollWheelZoom: this.wrapper.dataset.scrollwheelzoom === 'true',
            zoomControl: true,
        });
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(this.map);

        this.addMarkers();
        if (this.markers.length === 1) {
            const location = this.locations[0];
            this.map.setView([location.lat, location.lng], zoom);
            if (location.title) {
                this.markers[0].openPopup();
            }
        }
        else if (this.markers.length > 1) {
            this.map.fitBounds(L.featureGroup(this.markers).getBounds(), { padding: [30, 30] });
        }
        else {
            this.map.setView(center, zoom);
        }
    }

    addMarkers() {
        const pinColor = this.wrapper.dataset.pincolor || '#000';
        for (const location of this.locations) {
            if (!location?.lat || !location?.lng) {
                continue;
            }

            const marker = L.marker([location.lat, location.lng], {
                icon: L.icon({
                    iconUrl: markerIconSVG(pinColor), iconSize: [32, 32], iconAnchor: [16, 32], popupAnchor: [0, -32],
                }),
            });
            if (location.title) {
                marker.bindPopup(location.title);
            }
            marker.addTo(this.map);
            this.markers.push(marker);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.jims-maps.openstreetmap-map').forEach(element => new Map(element));
});
